import React, {useEffect, useRef, useState} from "react";
import {ExamProvider} from "../../contexts/ExamContext";
import ExamStart from "./ExamStart";
import ExamPage from "./ExamPage";
import ExamFinish from "./ExamFinish";
import {StudentExamService} from "../../service/StudentExamService";
import GeneralUtils from "../../utils/GeneralUtils";
import ExamFooter from "./ExamFooter";

const ExamContainer = (props) => {
    const {exam, fullWidth, setFullWidth, onStart, onFinish} = props;
    const [phase, setPhase] = useState("start");
    const [studentExam, setStudentExam] = useState(null);

    const examContainerRef = useRef(null);

    const studentExamService = new StudentExamService();

    useEffect(() => {
        setPhase("start");
    }, [exam]);


    const handleStart = () => {
        let data = {startedAt: new Date(), exam: exam.id};
        studentExamService.create(data).then((response) => {
            setStudentExam(response);
            setPhase("exam");
        });
    }

    const handleFinish = () => {
        if(!GeneralUtils.isNullOrEmpty(studentExam)) {
            studentExam.finishedAt = new Date();
            studentExamService.update(studentExam).then((response) => {
                setStudentExam(response);
                setPhase("finish");
            });
        }
    }

    // reset UI after finish screen reviewed
    const handleResetAfterReview = () => {
        setStudentExam(null);
        setPhase("start");
    };

    return (
        <div className="custom-container" ref={examContainerRef}>
            <ExamProvider exam={exam} studentExamId={studentExam?.id}>
                <div className="flex justify-content-center flex-wrap bg-white w-full h-full p-2">
                    {phase === "start" && <ExamStart props={props} onStart={handleStart}/>}

                    {phase === "exam" && <ExamPage onFinish={handleFinish} overlayRoot={examContainerRef}/>}

                    {phase === "finish" && <ExamFinish onClose={handleResetAfterReview} />}
                </div>
            </ExamProvider>

            <div className="controls">

                <ExamFooter
                    appendTo={examContainerRef}
                    fullWidth={fullWidth}
                    setFullWidth={setFullWidth}
                />
            </div>

        </div>
    );
};

export default ExamContainer;
